import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/Advertiser.graphql';
import { Query, QueryadvertiserArgs } from '../../__generated__/globalTypes';

export const useAdvertiserQuery = (options?: QueryHookOptions<Query, QueryadvertiserArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryadvertiserArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAdvertiserLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryadvertiserArgs>
): QueryResult<Query, QueryadvertiserArgs> & { getAdvertiser: LazyQueryExecFunction<Query, QueryadvertiserArgs> } => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAdvertiser, result] = useLazyQuery<Query, QueryadvertiserArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAdvertiser, ...result };
};

export const useAdvertiserPromiseQuery = () => {
  const client = useApolloClient();

  const getAdvertiser = useCallback(
    (options?: Omit<QueryOptions<QueryadvertiserArgs, Query>, 'query'>) =>
      client.query<Query, QueryadvertiserArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getAdvertiser };
};
// Suspense Query Hooks
export const useAdvertiserSuspenseQuery = (options?: SuspenseQueryHookOptions<Query, QueryadvertiserArgs>) => {
  const result = useSuspenseQuery<Query, QueryadvertiserArgs>(QUERY, {
    ...options
  });

  return result;
};
